import ProfilePage from './profile-page-container'
export default ProfilePage
